import { containerYardConstants } from '../../_constants';
import { containerYardService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const containerYardActions = {
    getAllContainerYards,
    getContainerYardById,
    createContainerYard,
    updateContainerYard,
    deleteContainerYard,
    activation,
    getActiveContainerYards
};

function cyFetched() { return { type: containerYardConstants.CY_FETCHED } }
function cyFetching() { return { type: containerYardConstants.CY_FETCHING } }

function cySubmitted() { return { type: containerYardConstants.CY_SUBMITTED } }
function cySubmitting() { return { type: containerYardConstants.CY_SUBMITTING } }

function getAllContainerYards(skip, take, filter, search) {
    return dispatch => {
        dispatch(cyFetching());
        dispatch(userActions.allowLeavePage());
        containerYardService.getAllContainerYards(skip, take, filter, search)
            .then(
                containerYards => {
                    if (containerYards.length > 0) {
                        dispatch(success(containerYards));
                        dispatch(cyFetched());
                    } else {
                        dispatch(cyFetched());
                        dispatch(alertActions.warning('No more data to load'))
                    }
                },
                error => {
                    dispatch(cyFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(containerYards) { return { type: containerYardConstants.GET_CONTAINER_YARDS, containerYards } }
}
function getContainerYardById(code) {
    return dispatch => {
        dispatch(cyFetching());
        dispatch(userActions.allowLeavePage());
        containerYardService.getContainerYardById(code)
            .then(
                containerYard => {
                    dispatch(success(containerYard))
                    dispatch(cyFetched());
                },
                error => {
                    dispatch(cyFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );

    };
    function success(containerYard) { return { type: containerYardConstants.GET_CONTAINER_YARD_BY_ID, containerYard } }
}
function createContainerYard(payload) {
    return dispatch => {
        dispatch(cySubmitting());
        dispatch(userActions.notallowLeavePage());
        containerYardService.createContainerYard(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cySubmitted());
                    dispatch(alertActions.success('Container Yard added successfully'))
                    window.location.href = '/master_data/container_yards';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cySubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateContainerYard(payload, id) {
    return dispatch => {
        dispatch(cySubmitting());
        dispatch(userActions.notallowLeavePage());
        containerYardService.updateContainerYard(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cySubmitted());
                    dispatch(alertActions.success('Container Yard updated successfully'))
                    window.location.href = '/master_data/container_yards';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(cySubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteContainerYard(id, type, take) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        containerYardService.deleteContainerYard(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Container Yard deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/container_yards';
                            break;
                        default:
                            dispatch(getAllContainerYards(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/container_yards';
                            break;
                        default:
                            dispatch(getAllContainerYards(0, take));
                            break;
                    }
                }
            );
    };
}
function activation(code, isActive) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        containerYardService.activation(code, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getContainerYardById(code));
                    dispatch(alertActions.success(isActive ? 'Container Yard activated successfully' : 'Container Yard deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function getActiveContainerYards() {
    return dispatch => {
        containerYardService.getActiveContainerYards()
            .then(
                activeContainerYards => dispatch(success(activeContainerYards)),
                error => {
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(activeContainerYards) { return { type: containerYardConstants.GET_ACTIVE_CONTAINER_YARDS, activeContainerYards } }
}